import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-dark-700 rounded-2xl p-8 shadow-2xl border border-dark-600">
        <div className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-6">
            <AlertTriangle className="w-8 h-8 text-red-400" />
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-2">
            Ops! Algo deu errado
          </h1>
          
          <p className="text-gray-400 mb-6">
            Ocorreu um erro inesperado. Tente novamente ou entre em contato com o suporte.
          </p>
          
          {process.env.NODE_ENV === 'development' && (
            <details className="mb-6 text-left">
              <summary className="text-sm text-gray-500 cursor-pointer mb-2">
                Detalhes do erro (desenvolvimento)
              </summary>
              <pre className="text-xs text-red-400 bg-dark-800 p-3 rounded-lg overflow-auto">
                {error.message}
              </pre>
            </details>
          )}
          
          <button
            onClick={resetErrorBoundary}
            className="w-full bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
          >
            <RefreshCw className="w-4 h-4" />
            Tentar Novamente
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
